export default "__VITE_ASSET__DimcorRC__"